import { Component, Input, OnInit } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { EnpsHelpModalComponent } from '../enps-help-modal/enps-help-modal.component';
import { PermissionsService } from 'src/app/services/permissions/permissions.service';
@Component({
  selector: 'app-enps-help',
  templateUrl: './enps-help.component.pug',
  styleUrls: ['./enps-help.component.scss'],
  standalone: false
})
export class EnpsHelpComponent implements OnInit {
  @Input() request;
  bsModalRef!: BsModalRef;

  constructor(private modalService: BsModalService, private permission: PermissionsService) {}

  ngOnInit(): void {}

  showHelp(): void {
    let initialState = { request: this.request };
    if (this.request == 'pulse') {
      this.bsModalRef = this.modalService.show(EnpsHelpModalComponent, {
        class: 'modal-centered max-height-468 min-width-554',
        initialState,
      });
    }
  }
}
